import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ClickOutsideDirective } from '@shared/directives/click-outside.directive';

import { DisableControlDirective } from '@shared/directives/disable-control.directive';

import { FormConnectDirective } from './form-connect.directive';
import { NgLetDirective } from './ng-let.directive';
import { TemplateTooltipDirective } from './template-tooltip.directive';

const components = [
  FormConnectDirective,
  DisableControlDirective,
  ClickOutsideDirective,
  NgLetDirective,
  TemplateTooltipDirective,
];

@NgModule({
  imports: [CommonModule, OverlayModule, ReactiveFormsModule],
  declarations: [...components],
  exports: [...components],
})
export class SharedDirectivesModule {}
